import { css } from 'styled-components';

export const StyledContainerBorder = css`
  background-color: ${p => p.theme.colors.white};
  border-radius: 8px;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
`;

export const StyledGrayContainer = css`
  background-color: ${p => p.theme.colors.gray100};
  border-radius: 4px;
  border: 1px solid ${p => p.theme.colors.gray300};
`;

export const StyledActionText = css`
  font-weight: 600;
`;
